<template>
  <v-container fluid class="superTable pa-0">
    <v-row no-gutters>
      <v-col sm="4">
        <v-text-field
          :placeholder="$t('actions.search')"
          class="superTable__search"
          clearable
          outlined
          prepend-inner-icon="mdi-magnify"
          v-model="search"
          @click:clear="search = '';keyup()"
          @keyup="keyup"
          @keyup.esc="search = ''"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col sm="12">
        <v-data-table
          v-model="selectedItems"
          :headers="headers"
          :items="data"
          :totalItems="totalItems"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          hide-default-footer
          show-select
          item-key="receiptId"
          class="superTable__table"
          style="table-layout: fixed"
          :sort-by="sortBy"
          :sort-desc="sortDesc"
          @update:sort-by="$emit('update:sortBy', Array.isArray($event) ? $event[0] : $event)"
          @update:sort-desc="$emit('update:sortDesc', Array.isArray($event) ? $event[0] : $event)"
        >
          <template v-slot:[`item.visible`]="{item}">
            <v-icon :color="(item.visible) ? 'success' : 'grey lighten-2'" size="12">mdi-circle</v-icon>
          </template>

          <template v-slot:[`item.average`]="{item}">
            <v-icon :color="(item.average) ? 'success' : 'grey lighten-2'" size="12">mdi-circle</v-icon>
          </template>

          <template v-slot:[`item.dateTo`]="{item}">
            {{ item.date || '-' }}
          </template>
          <template v-slot:[`item.amount`]="{item}">
            {{ item.amount | $currency }}
          </template>



          <template v-slot:top v-if="permissions.delete">
            <div :class="['superTable__bulkActions', 'py-2',selectedItems.length ? 'show' : 'hide']">
              <v-divider></v-divider>
              <div class="py-3">
                                <span
                                  v-if="permissions.delete"
                                  class="caption mx-4 cursor-pointer hover-7-inverted"
                                  @click="$emit('bulk-delete', selectedItems)"
                                >
                                    <v-icon size="22" class="mr-2">mdi-pencil</v-icon>{{ bulkTitle }}
                                </span>
              </div>
              <v-divider></v-divider>
            </div>
          </template>

          <template v-slot:[`header.data-table-select`]="{ on, props }">
            <v-simple-checkbox
              class="superTable__table__item__checkbox"
              color="primary"
              v-bind="props"
              v-on="on"
            ></v-simple-checkbox>
          </template>

          <template v-slot:[`item.data-table-select`]="{ isSelected, select, item }">
            <v-simple-checkbox
              class="superTable__table__item__checkbox"
              color="primary"
              :value="isSelected"
              @input="select($event)"
              v-show="isReceipt(item)"
            ></v-simple-checkbox>
          </template>

          <template v-slot:[`item.action`]="{ item }" v-if="permissions.create || permissions.update || permissions.delete">
            <v-menu bottom left>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" class="superTable__table__item__action">mdi-dots-vertical</v-icon>
              </template>
              <v-list class="pa-0">
                <v-list-item v-if="permissions.update && isReceipt(item)" @click="editItem(item)">
                  <v-list-item-title>
                    <v-icon>mdi-pencil</v-icon> {{ $t('modules.pricing.billing.superTable.itemGenerateNote') }}
                  </v-list-item-title>
                </v-list-item>
                <v-list-item v-if="permissions.delete &&  !isReceipt(item)" @click="deleteItem(item)">
                  <v-list-item-title>
                    <v-icon>mdi-delete</v-icon> {{ $t('modules.pricing.billing.superTable.itemDeleteReceipt') }}
                  </v-list-item-title>
                </v-list-item>
                <v-list-item v-if="permissions.update && isReceiptSent(item)" @click="receiptResend(item)">
                  <v-list-item-title>
                    <v-icon>mdi-refresh</v-icon> {{ $t('modules.pricing.billing.superTable.receiptResend') }}
                  </v-list-item-title>
                </v-list-item>
                <v-list-item v-if="permissions.update && isClientSent(item)"  @click="clientResend(item)">
                  <v-list-item-title>
                    <v-icon>mdi-refresh</v-icon> {{ $t('modules.pricing.billing.superTable.clientResend') }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
        <v-divider class="mt-4 mb-8"></v-divider>
      </v-col>
    </v-row>
    <v-row no-gutters align="center" v-show="totalItems">
      <v-col sm="3">
        <span class="caption d-inline-block">{{ `${itemsCount.startItem} - ${itemsCount.endItem} de ${itemsCount.totalItems}` }}</span>
        <v-select
          :items="itemsPerPageAvailable"
          :placeholder="itemsPerPage.toString()"
          class="superTable__paginationSelect d-inline-block ml-4"
          outlined
          v-model="itemsPerPage"
          @change="$emit('length-pagination-change', itemsPerPage)"
        ></v-select>
      </v-col>
      <v-col class="text-center" sm="6" >
        <v-pagination
          :value="page"
          :length="pageCount"
          @next="$emit('next-pagination', page)"
          @previous="$emit('previous-pagination', page)"
          @input="$emit('input-pagination', $event)"
          class="superTable__pagination"
        ></v-pagination>
      </v-col>
      <v-col align="right" sm="3">
        <v-text-field
          class="superTable__paginationInput d-inline-block mr-4"
          max="pageCount"
          outlined
          v-model.number="goToPage"
          @blur="changePage"
        ></v-text-field>
        <span class="caption d-inline-block">{{ $t('actions.goToPage') }}</span>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'SuperTable',
  props: {
    data: Array,
    headers: Array,
    clearSelected: String,
    bulkTitle: String,
    permissions: {update: false, delete: false},
    sortBy: String,
    sortDesc: Boolean,
    pageCount: { type: Number, default: 1 },
    page: { type: Number, default: 1 },
    totalItems: Number
  },
  data () {
    return {
      selectedItems: [],
      timeout: null,
      search: '',
      itemsPerPage: 20,
      itemsPerPageAvailable: [20, 50, 100, 200],
      goToPage: 1,
    }
  },
  methods: {
    keyup () {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.searchAction()
        clearTimeout(this.timeout);
      },1000)
    },
    searchAction() {
      this.$emit('searchAction', this.search)
    },
    changePage() {
      if (this.goToPage > this.pageCount) this.goToPage = this.page;
      else this.$emit('input-pagination', this.goToPage)
    },
    editItem (item) {
      item ? this.$emit('updateData', item) : null
    },
    deleteItem (id) {
      this.$emit('deleteData', id);
    },
    duplicateItem (id) {
      this.$emit('duplicateData', id);
    },
    isReceipt(value){
       return !value.receiptType.toLowerCase().includes('recibo')
    },
    isReceiptSent(receipt){
      return receipt.receiptDetail.sapEvent == true;
    },
    isClientSent(receipt){
      return receipt.receiptDetail.studentSapEvent == true;
    },
    clientResend (item){
      this.$emit('clientResend', item);
    },
    receiptResend (item){
      this.$emit('receiptResend', item);
    }
  },
  watch: {
    page (val) {
      if (val > this.pageCount) this.page = this.pageCount;
      if (val < 1) this.page = 1;
      if (this.page !== this.goToPage) this.goToPage = this.page;
    },
    clearSelected() {
      this.selectedItems = []
    },
  },
  computed: {
    itemsCount() {
      const counter = {
        totalItems: this.totalItems,
        startItem: ((this.page * this.itemsPerPage) - this.itemsPerPage) + 1,
        endItem: this.page * this.itemsPerPage
      };

      if (counter.endItem > this.totalItems) counter.endItem = this.totalItems
      return counter
    }
  },
};
</script>
